import React from "react";
import { AnswerResultFrame } from "./AnswerResultFrame";

export function WrongAnswerScreen({
  open,
  onClose,
  accent = "WRONG",
  rest = "ANSWER",
  message = "",
  reward = "",
  cta = "GOT IT",
}) {
  return (
    <AnswerResultFrame
      open={open}
      onClose={onClose}
      accent={accent}
      accentColor="#FF8A1E"
      rest={rest}
      body={message}
      reward={reward}
      rewardColor="#8E9480"
      cta={cta}
      fadedEgg
    />
  );
}
